import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { FaApple } from 'react-icons/fa';
import axios from 'axios';

export default function AppleSignInButton({ setUser, navigate }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    window.AppleID.auth.init({
      clientId:   process.env.REACT_APP_APPLE_CLIENT_ID,
      scope:      'name email',
      redirectURI: process.env.REACT_APP_APPLE_REDIRECT_URI,
      usePopup:   true,
      state:      crypto.randomUUID(),
      nonce:      crypto.randomUUID(),
    });
    setReady(true);

    const onSuccess = async (e) => {
      try {
        const { authorization, user } = e.detail;
        console.log('Apple sign-in user:', user); 

        const { data, headers } = await axios.post(
          '/apple/login',
          { identityToken: authorization.id_token, user },
          { withCredentials: true }
        );


        if (data.link_pending) {
          navigate('/link', {
            state: {
              email:    data.email,    
              apple_id: data.apple_id 
            }
          });
          return;                    
        }

        sessionStorage.setItem('token', headers.authorization);
        sessionStorage.setItem('user', JSON.stringify(data.user));
        axios.defaults.headers.common.Authorization = headers.authorization;
        setUser(data.user);

        navigate(data.user.cliente_id ? '/customer/dashboard' : '/admin/dashboard');
      } catch (err) {
        if (err.response?.status === 400 && err.response.data?.link_pending) {
          const { email, apple_id } = err.response.data;
          navigate('/link', { state: { email, apple_id } });
          return;
        }

        console.error('Apple sign-in error:', err);
        message.error(err.response?.data?.message || err.message);
  
      }
    };

    const onFailure = (e) => {
      const { error } = e.detail;
      if (
        error === 'popup_closed_by_user' ||
        error === 'user_cancelled_authorize'
      ) {
        message.info('Has cancelado el inicio de sesión.');
        return;
      }
      console.error('Apple failure:', e.detail);
      message.error(
        typeof error === 'string' ? error : JSON.stringify(error)
      );
    };

    document.addEventListener('AppleIDSignInOnSuccess', onSuccess);
    document.addEventListener('AppleIDSignInOnFailure', onFailure);

    return () => {
      document.removeEventListener('AppleIDSignInOnSuccess', onSuccess);
      document.removeEventListener('AppleIDSignInOnFailure', onFailure);
    };
  }, [setUser, navigate]);

  return (
    <Button
      icon={<FaApple style={{ fontSize: 20, marginRight: 8 }} />}
      block
      size="large"
      disabled={!ready}
      style={{
        backgroundColor: '#000',
        color: '#fff',
        border: 'none',
        opacity: ready ? 1 : 0.6,
      }}
      onClick={() =>
        window.AppleID.auth
          .signIn()
          .catch((err) => {
            if (
              err?.error === 'popup_closed_by_user' ||
              err?.error === 'user_cancelled_authorize'
            ) {
              message.info('Has cancelado el inicio de sesión.');
              return;
            }
            const msg =
              typeof err === 'string'
                ? err
                : err?.error || err?.message || JSON.stringify(err);
            message.error(msg);
          })
      }
    >
      Sign in with Apple
    </Button>
  );
}
